import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import {createFeatureHub} from '@feature-hub/core';
import {defineLogger} from '@feature-hub/logger';
import {FeatureHubContextProvider, FeatureAppContainer} from '@feature-hub/react';
import {defineExternals, loadAmdModule} from '@feature-hub/module-loader-amd';
import {ServicioAutenticacion} from 'autenticacion_servicio';

defineExternals({react: React});

const {featureAppManager} = createFeatureHub('dto:admin:integrator',{
    featureServiceDefinitions: [
        defineLogger(),
        ServicioAutenticacion
    ],
    moduleLoader: loadAmdModule,
    providedExternals: {react: '16.13.1'}
});

ReactDOM.render(
  <FeatureHubContextProvider value={{featureAppManager}}>
    <React.StrictMode>
      <FeatureAppContainer featureAppId="dto:admin:app" featureAppDefinition={App} />
    </React.StrictMode>
  </FeatureHubContextProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
